import * as actionTypes from '../types/support';

/** Активности с модальным окном */
export function openSupportWindow() {
  return {
    type: actionTypes.OPEN_SUPPORT_WINDOW
  };
}
export function openSupportWindowSuccess() {
  return {
    type: actionTypes.OPEN_SUPPORT_WINDOW_SUCCESS
  };
}
export function closeSupportWindow() {
  return {
    type: actionTypes.CLOSE_SUPPORT_WINDOW
  };
}
export function setSupportInfo(payload) {
  return {
    type: actionTypes.SET_SUPPORT_INFO,
    payload
  };
}

/** Получить номер обращения */
export function getSupportNextNumber(payload) {
  return {
    type: actionTypes.GET_SUPPORT_NEXT_NUMBER,
    payload
  };
}
export function getSupportNextNumberSuccess(payload) {
  return {
    type: actionTypes.GET_SUPPORT_NEXT_NUMBER_SUCCESS,
    payload
  };
}
export function getSupportNextNumberFail(payload) {
  return {
    type: actionTypes.GET_SUPPORT_NEXT_NUMBER_FAIL,
    payload
  };
}

/** Добавление фото */
export function supportAddPhoto(payload) {
  return {
    type: actionTypes.SUPPORT_ADD_PHOTO,
    payload
  };
}
export function supportAddPhotoSuccess(payload) {
  return {
    type: actionTypes.SUPPORT_ADD_PHOTO_SUCCESS,
    payload
  };
}
export function supportAddPhotoFail(payload) {
  return {
    type: actionTypes.SUPPORT_ADD_PHOTO_FAIL,
    payload
  };
}

/** Удаление фото */
export function supportDelPhoto(payload) {
  return {
    type: actionTypes.SUPPORT_DEL_PHOTO,
    payload
  };
}
export function supportDelPhotoSuccess(payload) {
  return {
    type: actionTypes.SUPPORT_DEL_PHOTO_SUCCESS,
    payload
  };
}
export function supportDelPhotoFail(payload) {
  return {
    type: actionTypes.SUPPORT_DEL_PHOTO_FAIL,
    payload
  };
}

/** Получение списка фотографий */
export function supportGetListPhotos(payload) {
  return {
    type: actionTypes.SUPPORT_GET_LIST_PHOTOS,
    payload
  };
}
export function supportGetListPhotosSuccess(payload) {
  return {
    type: actionTypes.SUPPORT_GET_LIST_PHOTOS_SUCCESS,
    payload
  };
}
export function supportGetListPhotosFail(payload) {
  return {
    type: actionTypes.SUPPORT_GET_LIST_PHOTOS_FAIL,
    payload
  };
}

/** Отправка сообщения */
export function supportSendEmail(payload) {
  return {
    type: actionTypes.SUPPORT_SEND_EMAIL,
    payload
  };
}
export function supportSendEmailSuccess(payload) {
  return {
    type: actionTypes.SUPPORT_SEND_EMAIL_SUCCESS,
    payload
  };
}
export function supportSendEmailFail(payload) {
  return {
    type: actionTypes.SUPPORT_SEND_EMAIL_FAIL,
    payload
  };
}

/** Удалить номер обращения */
export function delSupportNumber() {
  return {
    type: actionTypes.DEL_SUPPORT_NUMBER
  };
}
